import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useGenericTranslation = () => {
  const { t } = useTranslation();
  const market = useSelector((state) => state.app.currentMarket);
  const templateNameId = market.templateNameId;

  const getClientTranslation = (key) => {
    return t(`genericWords.${templateNameId}.${key}`);
  };

  return { getClientTranslation };
};

export default useGenericTranslation;
